module.exports = __webpack_public_path__ + "8e88eeea5437527b58a6c92f2ad0dbd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Logos/PPN_ASSETS/WalletCard_2023_StudyInsured_fr.jpg
// module id = 1568
// module chunks = 0